import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CxTableService } from '../services/cx-table.service';

@Directive({ selector: '[cxColumnSort]' })
export class CxColumnSortDirective {
  @Input() cxColumnSort: any = {};
  @Input() order = -1;
  @Output() sort = new EventEmitter();

  constructor(public tableService: CxTableService) {}

  @HostListener('click', ['$event']) onClick($event: any) {
    if (this.cxColumnSort.sort === false) {
      return;
    }
    this.cxColumnSort.order = this.cxColumnSort.order === 1 ? 0 : this.cxColumnSort.order === 0 ? 1 : 1;
    this.sort.emit(this.cxColumnSort);
    this.tableService.$sort.next(this.cxColumnSort);
  }
}
